/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from "react";

import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
//@ts-ignore
import ScrollText from "react-scroll-text";
import VerticalCarouselWidget from "../vertical-carousel-widget-react";
import Card from "react-bootstrap/Card";
import { useWindowSize } from "@react-hook/window-size/throttled";
import "./custom.css";

type ContainerContentProps = {
  leftColumnHeader?: string;
  rightColumnHeader?: string;
  paymentQueue?: {
    counterTitle?: string;
    cardColor?: string;
  };
  collectionQueue?: {
    counterTitle?: string;
    cardColor?: string;
  };
};

interface TokenContainerProps {
  cardData?: any[];
  containerContent?: ContainerContentProps;
  [key: string]: any;
}
// let renderCount = 0;
export const TokenContainer = (props: TokenContainerProps) => {
  const { cardData, containerContent, bandLogo } = props;
  const [width, height] = useWindowSize();
  let leftColumn: any[] = [];
  let rightColumn: any[] = [];
  let userData =
    cardData && cardData !== null && cardData.length > 0 ? cardData : [];

  // console.log(`TokenContainer rerender`);
  // renderCount += 1;
  // console.log(`${TokenContainer.name}. renderCount: `, renderCount);

  const _getGeneralFontStyle = () => {
    let _styles = {
      fontSize: height * 0.048,
    };
    return _styles;
  };

  const _getCounterFontStyle = () => {
    let _styles = {
      fontSize: height * 0.038,
    };
    return _styles;
  };
  cardData?.calledoutData &&
    Array.isArray(cardData?.calledoutData) &&
    cardData?.calledoutData.length > 0 &&
    cardData?.calledoutData.map((element: any, index: number) => {
      leftColumn.push(
        <Card key={`left-coll-${index}`} className="bg-transparent">
          <div
            style={{
              ...styles?.leftGrid,
              backgroundColor:
                element.isPayerCalledOut && element.payerCounterNo
                  ? containerContent?.paymentQueue?.cardColor
                  : containerContent?.collectionQueue?.cardColor,
              borderBottom: "5px solid white",
            }}
          >
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Grid item xs={8}>
                <Typography
                  style={{
                    ...styles?.tokenStyle,
                    ..._getGeneralFontStyle(),
                  }}
                >
                  {element.token}
                  <br />
                  <span
                    style={{
                      ...styles?.nameStyle,
                      ..._getGeneralFontStyle(),
                    }}
                  >
                    <ScrollText speed={60}>{element.fullName}</ScrollText>
                  </span>
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography
                  style={{
                    ...styles?.counterStyle,
                    ..._getCounterFontStyle(),
                  }}
                >
                  {element.isPayerCalledOut && element.payerCounterNo
                    ? containerContent?.paymentQueue?.counterTitle
                    : element.isDistributorCounterCalledOut &&
                      element.distributorCounterNo
                    ? containerContent?.collectionQueue?.counterTitle
                    : "Counter"}{" "}
                  <br />
                  <span style={styles?.numberStyle}>
                    {" "}
                    {element.payerCounterNo ||
                      element.distributorCounterNo}{" "}
                  </span>
                </Typography>
              </Grid>
            </Grid>
          </div>
        </Card>
      );
    });
  cardData?.waitingQData &&
    Array.isArray(cardData?.waitingQData) &&
    cardData?.waitingQData.length > 0 &&
    cardData?.waitingQData.map((element: any, index: number) => {
      rightColumn.push(
        <Card key={`right-col-${index}`} className="bg-transparent">
          <div
            style={{
              ...styles?.rightGrid,
              borderBottom: "5px solid white",
            }}
          >
            <Grid container direction="row">
              <Grid item xs={4}>
                <Typography
                  style={{
                    ...styles?.tokenStyle,
                    ..._getGeneralFontStyle(),
                    paddingLeft: "10px",
                  }}
                >
                  {element.token}
                </Typography>
              </Grid>
              <Grid item xs={8}>
                <Typography
                  style={{
                    ...styles?.nameStyle,
                    ..._getGeneralFontStyle(),
                  }}
                >
                  <ScrollText speed={60}>{element.fullName}</ScrollText>
                </Typography>
              </Grid>
            </Grid>
          </div>
        </Card>
      );
    });

  return (
    <div style={styles?.containerStyle}>
      <Grid container justifyContent="space-around" alignItems="stretch">
        <Card.Img
          src={bandLogo}
          className="avatar-sm mx-auto mt-n6 mb-4"
          style={{
            ...styles?.imageStyle,
            height: width * 0.09,
            width: width * 0.09,
          }}
        />
        <Grid item sm={5} xs={12}>
          {/* <div style={StyleSheet.flatten([styles?.columnHeaderStyle])}>
          {containerContent?.leftColumnHeader}
        </div> */}
          <VerticalCarouselWidget
            carouselData={leftColumn}
            slidesToShow={leftColumn.length < 4 ? leftColumn.length : 4}
            slidesToScroll={2}
            carouselSpeed={5000}
          />
        </Grid>
        <Grid item sm={1} xs={12}>
          <Divider
            orientation="vertical"
            style={{
              ...styles?.gridStyle,
              backgroundImage: "linear-gradient(#ff2f2f, #ffdd00)",
            }}
          />
        </Grid>
        <Grid item sm={5} xs={12}>
          {/* <div style={StyleSheet.flatten([styles?.columnHeaderStyle])}>
          {containerContent?.rightColumnHeader}
        </div> */}
          <VerticalCarouselWidget
            carouselData={rightColumn}
            slidesToShow={rightColumn.length < 6 ? rightColumn.length : 7}
            slidesToScroll={3}
            carouselSpeed={7000}
          />
        </Grid>
      </Grid>
    </div>
  );
};

const styles = {
  containerStyle: {
    padding: 20,
  },
  imageStyle: {
    position: "absolute",
    top: "50%",
    zIndex: 9999,
  },
  // columnHeaderStyle: {
  //   justifyContent: "center",
  //   display: "flex",
  //   color: "#ffffff",
  //   fontSize: 40,
  //   fontWeight: "700",
  // },
  gridStyle: {
    width: 4,
    height: "90vh",
    borderRadius: 10,
    margin: "0 auto",
  },
  tokenStyle: {
    fontSize: 40,
    color: "#fff",
    fontWeight: "700",
    paddingBottom: 0,
  },
  nameStyle: {
    color: "#fff",
    fontWeight: "700",
    textTransform: "capitalize",
  },
  counterStyle: {
    color: "#fff",
    fontWeight: "700",
    textAlign: "center",
  },
  numberStyle: {
    fontSize: "50",
    color: "#fff",
    fontWeight: "700",
    textalign: "center",
  },
  leftGrid: {
    margin: "4px 0",
    //backgroundColor: "#0a5717",
    opacity: "none",
    borderBottom: "3px solid #fff",
    borderRadius: 15,
    padding: 7,
  },
  rightGrid: {
    margin: "10px 0",
    backgroundColor: "rgba(5, 5, 5, 0.5)",
    borderBottom: "3px solid #fff",
    borderRadius: 15,
  },
};

// export default React.memo(TokenContainer);
